import type { FC } from 'react';

import styles from './Toast.module.scss';

interface ToastProps {
    message: string;
    visible: boolean;
}

export const Toast: FC<ToastProps> = ({ message, visible }) => (
    <div className={`${styles.toast} ${visible ? styles.visible : ''}`} role="status" aria-live="polite">
        {message}
    </div>
);